import { JobBoxTab, MatchedJob } from '../../../../../store/workspace/types';
import { getMatchedJobsThunk } from '../../../../../store/workspace/thunks';
import { useDispatch, useSelector } from '../../../../../store/store';
import CodingExamCard from '../../../../../components/CodingExamCard';
import { setJobBoxTab } from '../../../../../store/workspace/slice';
import { selectUserId } from '../../../../../store/auth/selectors';
import InterviewCard from '../../../../../components/InteviewCard';
import { InfoIcon } from '../../../../../assets/icons/common';
import DropDown from '../../../../../components/DropDown';
import Spinner from '../../../../../components/Spinner';
import JobCard from '../../../../../components/JobCard';
import Button from '../../../../../components/Button';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';
import { useEffect } from 'react';
import {
    selectJobBoxTab,
    selectMatchedJobs,
    selectExamsHistory,
    selectLoadingMatchedJobs,
} from '../../../../../store/workspace/selectors';

interface TabItem {
    id: JobBoxTab;
    title: string;
}

const tabList: TabItem[] = [

    {
        id: 'RecruitingInterview',
        title: 'Recruiting interview',
    },

    {
        id: 'MultipleChoice',
        title: 'Multiple choice',
    },
    {
        id: 'Coding',
        title: 'Coding',
    },
    {
        id: 'Interview',
        title: 'Personal interview',
    },
    {
        id: 'FinalResult',
        title: 'Final result',
    },
];

interface Props {
    disabledMatching: boolean;
    matchedJobs?: MatchedJob[];
};

function JobBox(props: Props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { disabledMatching } = props;
    const tab = useSelector(selectJobBoxTab);
    const userId = useSelector(selectUserId);
    const jobs = useSelector(selectMatchedJobs);
    const history = useSelector(selectExamsHistory);
    const loading = useSelector(selectLoadingMatchedJobs);
    const codingExams = jobs.filter(i => i.status === 'codingExam');
    const interviewList = history.filter(i => i.status === 'interview');
    const finalResultList = history.filter(i => i.status === 'finalResult');
    const multipleChoiceExam = jobs.filter(i => i.status === 'multipleChoiceExam');
    const recruitingInterview = jobs.filter(i => i.status === 'recruitingInterview');

    useEffect(() => {
        if (!userId) return;
        dispatch(getMatchedJobsThunk(userId));
    }, [userId]);

    return (
        <div className={styles.wrapper}>
            <span className={styles.title}>
                Potential jobs based on your profile
            </span>

            <div className={styles.tab}>
                <div
                    className={styles.tab_item}
                    onClick={() => dispatch(setJobBoxTab('RecruitingInterview'))}
                    data-is-active={tab === 'RecruitingInterview'}
                >
                    <span>Recruiting interview</span>
                </div>
                <div
                    className={styles.tab_item}
                    onClick={() => dispatch(setJobBoxTab('MultipleChoice'))}
                    data-is-active={tab === 'MultipleChoice'}
                >
                    <span>Multiple choice</span>
                </div>
                <div
                    className={styles.tab_item}
                    onClick={() => dispatch(setJobBoxTab('Coding'))}
                    data-is-active={tab === 'Coding'}
                >
                    <span>Coding</span>
                </div>
                <div
                    className={styles.tab_item}
                    onClick={() => dispatch(setJobBoxTab('Interview'))}
                    data-is-active={tab === 'Interview'}
                >
                    <span>Personal interview</span>
                </div>
                <div
                    className={styles.tab_item}
                    onClick={() => dispatch(setJobBoxTab('FinalResult'))}
                    data-is-active={tab === 'FinalResult'}
                >
                    <span>Final result</span>
                </div>
            </div>

            <DropDown
                idKey='id'
                titleKey='title'
                dropDownList={tabList}
                containerClassName={styles.tab_dropdown}
                selectedItem={tabList.find(item => item.id === tab)}
                setItem={(item: TabItem) => dispatch(setJobBoxTab(item.id))}
            />

            {!disabledMatching && <div className={styles.jobList}>
                {loading && <Spinner />}
                {!loading && tab === 'RecruitingInterview' &&
                    (recruitingInterview.length > 0 ? recruitingInterview.map(job => <JobCard tab='recruitingInterview' CtaTitle='Start recruiting interview' jobDetail={job} />) :
                        <span className={styles.jobList_empty_state}>
                            There are no matched recruiting interview available for you.<br />
                            Please come back later.
                        </span>)}
                {!loading && tab === 'MultipleChoice' && (multipleChoiceExam.length > 0 ? multipleChoiceExam.map(job => <JobCard tab='multipleChoiceExam' jobDetail={job} />) :
                    <span className={styles.jobList_empty_state}>
                        There are no matched multiple-choice exams available for you.<br />
                        Please come back later.
                    </span>)}
                {!loading && tab === 'Coding' && (codingExams.length > 0 ? codingExams.map(job => <CodingExamCard jobDetail={job} />) :
                    <span className={styles.jobList_empty_state}>
                        There are no coding exams available for you.<br />
                        Please come back later.
                    </span>)}
                {!loading && tab === 'Interview' && (interviewList.length > 0 ? interviewList.map(job => <InterviewCard jobDetail={job} />) :
                    <span className={styles.jobList_empty_state}>
                        There are no personal interviews available for you.<br />
                        Please come back later
                    </span>)}
                {!loading && tab === 'FinalResult' && (finalResultList.length > 0 ? finalResultList.map(job => <InterviewCard jobDetail={job} showStatus />) :
                    <span className={styles.jobList_empty_state}>
                        There are no final results available for you.<br />
                        Please come back later
                    </span>)}
            </div>}
            {disabledMatching && <div className={styles.jobList}>
                <div className={styles.jobList_setting}>
                    <InfoIcon />
                    <span>First, change your status to actively looking for a new job in settings.</span>
                </div>
                <br /><br />
                <Button text='Navigate To Settings' onClick={() => navigate('/workspace/settings')} />
            </div>}
        </div>
    )
};

export default JobBox;
